import {
  compose,
  withStateHandlers,
  withHandlers,
  lifecycle,
  shouldUpdate,
} from 'recompose';
import { addProps } from 'utils/recompose';
import { difference, filter, includes } from 'lodash';

export const setOption = ({
  originalOptions,
  setSelectedOption,
  filterName,
  setActiveFilters,
  selectedOptions,
}) => value => {
  let option = originalOptions.find(o => o.description === value);
  let selected = [...selectedOptions, option];
  let remainingOptions = difference(originalOptions, selected);
  setActiveFilters({
    newFilter: selected,
    designOption: filterName,
  });
  setSelectedOption(selected, remainingOptions);
};

export const setSelectedOption = state => (selected, remaining) => {
  return {
    ...state,
    search: '',
    selectedOptions: selected,
    filteredOptions: remaining,
  };
};

export const clearFilter = ({ originalOptions }) => () => {
  return {
    search: '',
    filteredOptions: originalOptions,
    selectedOptions: [],
  };
};

export const removeOption = (
  { originalOptions, selectedOptions },
  { clearFilter, filterName },
) => optionToRemove => {
  const newOptions = difference(originalOptions, optionToRemove);
  const newSelectedOptions = selectedOptions.filter(
    selectedOption => selectedOption.id !== optionToRemove.id,
  );
  clearFilter && clearFilter({ designOption: filterName, newSelectedOptions });
  return {
    search: '',
    filteredOptions: newOptions,
    selectedOptions: newSelectedOptions,
  };
};

const menuStyles = () => ({
  zIndex: 10,
  border: '1px solid lightgrey',
  borderRadius: ' 2px',
  maxHeight: '80px',
  overflowY: 'auto',
  boxSizing: 'border-box',
  position: 'absolute',
  top: '100%',
  left: 0,
  background: 'white',
});

export const searchMenuVisibility = () => isOpen => {
  if (typeof isOpen === 'boolean') {
    return { menuOpen: isOpen };
  } else {
    return { menuOpen: false };
  }
};

const filterOption = ({ originalOptions }) => e => {
  const value = e.target.value.toLowerCase();
  let filtered = filter(originalOptions, option => {
    let id = option.id.toLowerCase();
    let description = option.description.toLowerCase();
    return includes(id, value) || includes(description, value);
  });
  return { search: e.target.value, filteredOptions: filtered };
};

export const openDropdown = () => () => {
  return { menuOpen: true };
};

export const closeDropdown = () => () => {
  return { menuOpen: false };
};

const setInitialOptions = ({
  originalOptions = [],
  setSelectedOption,
}) => activeFilters => {
  let selectedOptions = activeFilters.map(filter =>
    originalOptions.find(o => o.description === filter.description),
  );
  let remainingOptions = difference(originalOptions, selectedOptions);
  setSelectedOption(selectedOptions, remainingOptions);
};

function componentDidMount() {
  const { activeFilters, setInitialOptions } = this.props;
  if (activeFilters) {
    setInitialOptions(activeFilters);
  }
}

const updateIfFiltersCleared = (
  { activeFilters: oldActiveFilters },
  { activeFilters: newActiveFilters, clearFilter },
) => {
  if (oldActiveFilters !== newActiveFilters && newActiveFilters === null) {
    clearFilter();
    return true;
  }
  return true;
};

export default compose(
  addProps({ menuStyles }),
  withStateHandlers(
    ({ options = [] }) => ({
      search: '',
      originalOptions: options,
      filteredOptions: options,
      selectedOptions: [],
    }),
    { filterOption, setSelectedOption, removeOption, clearFilter },
  ),
  withStateHandlers(
    {
      menuOpen: false,
    },
    { openDropdown, searchMenuVisibility },
  ),
  withHandlers({
    setOption,
    setInitialOptions,
  }),
  lifecycle({ componentDidMount }),
  shouldUpdate(updateIfFiltersCleared),
);
